import { combineReducers } from 'redux';

import * as Connection from './modules/connection';
import * as LocalSettings from './modules/localSettings'
import * as Settings from './modules/settings';
import * as Team from './modules/team';
import * as Timer from './modules/timer';


export default combineReducers({
    connection: Connection.reducer,
    localSettings: LocalSettings.reducer,
    settings: Settings.reducer,
    team: Team.reducer,
    timer: Timer.reducer,
});



// WEBPACK FOOTER //
// ./src/redux/rootReducer.ts